import { APP_INITIALIZER,ApplicationConfig, importProvidersFrom, SecurityContext} from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withInMemoryScrolling
} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';

import {routes} from './app.routes';
import {HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http';
import {environment} from '../environments/environment';
import {API_URL, AppInitializationService, errorInterceptor, httpRequestInterceptor, httpRequestUserActivityInterceptor} from 'lib-base';
import {MessageService} from 'primeng/api';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {RECAPTCHA_SETTINGS, RECAPTCHA_V3_SITE_KEY, RecaptchaSettings} from 'ng-recaptcha';
import {MARKED_OPTIONS, provideMarkdown} from "ngx-markdown";

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function initializeAppFactory(appInitService: AppInitializationService) {
  return () => appInitService.initializeApp();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: API_URL,
      useValue: environment.apiUrl
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideRouter(routes, inMemoryScrollingFeature),
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [AppInitializationService],
      multi: true
    },
    provideHttpClient(
      withInterceptors([errorInterceptor, httpRequestInterceptor, httpRequestUserActivityInterceptor])
    ),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    provideMarkdown({
       markedOptions:{
        provide: MARKED_OPTIONS,
         useValue: {
           gfm: true,
           breaks: true,
           pedantic: false,
         },
      },
      sanitize: SecurityContext.NONE
    }),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaV2SiteKey } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaV3SiteKey,
    }
  ]
};
